import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild, inject } from '@angular/core';
import { ActionIconDef, Grid, GridActionIconClickEvent, GridConfig, GridHyperlinkClickEvent } from '@inavista/components/grid';
import { SharedService } from 'projects/shared/src/lib/shared.service';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { UserRoles } from 'projects/shared/src/lib/lib.constants';
import { exportInavistaGrid } from 'projects/service/src/app/shared/utils/inavista-grid-export';
import { reportersActionIcons, reportersGridConfig, SELECT_ACTION } from './vr-resources-popup.grid.config';

// The request popup's reporter choice, on @inavista/components (vr-resources-popup.grid.config.ts). Select hands the row
// back to the request popup (onClose); the ID opens the user's profile; Close hands back true, as before.
@Component({
    selector: 'app-vr-resources-popup',
    templateUrl: './vr-resources-popup.component.html',
    styleUrls: ['./vr-resources-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VrResourcesPopupComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @ViewChild('reportersGrid') grid?: Grid;

  private readonly cdr = inject(ChangeDetectorRef);

  isExpanded = false;
  sales = false;
  gridConfig!: GridConfig;
  readonly actionIcons: ActionIconDef[] = reportersActionIcons();
  showUserProfilePopup = false;
  userProfile: any;

  constructor(
    private sharedService: SharedService,
    @Inject(APP_CONFIG) public config: AppConfig,
  ) {}

  ngOnInit() {
    this.sales = this.config.appName === 'sales';
    const canExport = this.sharedService.getUSER()?.role !== UserRoles.salesRep;
    this.gridConfig = reportersGridConfig(this.config.masterApiURL ?? '', this.sales, canExport);
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey === SELECT_ACTION) this.onClose.emit(event.row);
  }

  onHyperlinkClick(event: GridHyperlinkClickEvent) {
    this.userProfile = { ...event.row, name: event.row['employeeName'] };
    this.showUserProfilePopup = true;
    this.cdr.markForCheck();
  }

  onExportRequested() {
    if (this.grid) exportInavistaGrid(this.grid, 'Sales Representatives');
  }

  close() {
    this.onClose.emit(true);
  }

  expandCollapse() {
    this.isExpanded = !this.isExpanded;
  }
}
